import PropTypes from 'prop-types'
import { Button, Flex, Text } from '@chakra-ui/react'
import { MdKeyboardArrowLeft, MdKeyboardDoubleArrowLeft, MdKeyboardArrowRight, MdKeyboardDoubleArrowRight } from 'react-icons/md'

export const UiPagination = ({ curPage, totalPages, onSelect, ...rest }) => {
  return (
    <Flex
      w="100%"
      justifyContent="space-between"
      {...rest}
    >
      <Text fontSize="sm">{curPage} of {totalPages} pages</Text>
      <Flex>
        <UiPaginationButton onClick={() => onSelect(1)} isDisabled={curPage === 1}><MdKeyboardDoubleArrowLeft size="18px" /></UiPaginationButton>
        <UiPaginationButton onClick={() => onSelect(curPage - 1)} isDisabled={curPage === 1}><MdKeyboardArrowLeft size="18px" /></UiPaginationButton>
        {curPage > 3 && (
          <UiPaginationButton onClick={() => onSelect(curPage - 3)}>...</UiPaginationButton>
        )}
        {curPage > 2 && (
          <UiPaginationButton onClick={() => onSelect(curPage - 2)}>{curPage - 2}</UiPaginationButton>
        )}
        {curPage > 1 && (
          <UiPaginationButton onClick={() => onSelect(curPage - 1)}>{curPage - 1}</UiPaginationButton>
        )}
        <UiPaginationButton active={true}>{curPage}</UiPaginationButton>
        {curPage + 1 <= totalPages && (
          <UiPaginationButton onClick={() => onSelect(curPage + 1)}>{curPage + 1}</UiPaginationButton>
        )}
        {curPage + 2 <= totalPages && (
          <UiPaginationButton onClick={() => onSelect(curPage + 2)}>{curPage + 2}</UiPaginationButton>
        )}
        {curPage + 3 <= totalPages && (
          <UiPaginationButton onClick={() => onSelect(curPage + 3)}>...</UiPaginationButton>
        )}
        <UiPaginationButton onClick={() => onSelect(curPage + 1)} isDisabled={curPage === totalPages}><MdKeyboardArrowRight size="18px" /></UiPaginationButton>
        <UiPaginationButton onClick={() => onSelect(totalPages)} isDisabled={curPage === totalPages}><MdKeyboardDoubleArrowRight size="18px" /></UiPaginationButton>
      </Flex>
    </Flex>
  )
}

UiPagination.propTypes = {
  curPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired
}

const UiPaginationButton = ({ active = false, children, ...rest }) => {
  return (
    <Button
      size="sm"
      variant={active ? 'solid' : 'ghost'}
      colorScheme={active ? 'blue' : 'gray'}
      {...rest}
    >
      {children}
    </Button>
  )
}

UiPaginationButton.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node
}
